import React from 'react'
import { DefaultErrorPage } from './DefaultErrorPage'
import { ErrorBoundary } from './ErrorBoundary'
import { HoneybadgerProvider } from './Honeybadger'

export function AppErrorBoundary({ children }) {
  return (
    <HoneybadgerProvider>
      <ErrorBoundary renderError={() => <DefaultErrorPage />}>
        {children}
      </ErrorBoundary>
    </HoneybadgerProvider>
  )
}
